import type { ChartGroup } from '@integratio/core';
import { formatPercent } from '../../lib/format';
import { IsoBlockChart, type IsoCell } from './IsoBlockChart';
import { IsoLegend } from './IsoLegend';

interface Props {
  groups: ChartGroup[];
  total: number;
  /** Layout de impressão: listas completas e proporções fixas. */
  print?: boolean;
}

export function ContextEnvironmentChart({ groups, total, print = false }: Props): JSX.Element {
  const positioned = groups.filter((group) => group.matrix);
  const cells: IsoCell[] = positioned.map((group) => ({
    key: group.key,
    name: group.name,
    color: group.color,
    value: group.percentage,
    label: formatPercent(group.percentage),
    row: group.matrix!.row,
    col: group.matrix!.col,
    side: group.key === 'favoravel' ? 'right' : undefined,
  }));

  return (
    <div className={print ? 'grid grid-cols-[300px_1fr] gap-6' : 'grid gap-8 xl:grid-cols-[300px_1fr]'}>
      <IsoLegend groups={groups} total={total} limit={print ? Infinity : 8} showNames={!print} />
      <div className="min-w-0">
        <IsoBlockChart
          cells={cells}
          rows={3}
          cols={2}
          axisLeft="Posicionamento"
          axisRight="Poder"
          width={1040}
          height={print ? 560 : 720}
          showExternalValues={false}
          showCellLabels={false}
          railPadding={print ? 144 : undefined}
          className="h-auto w-full"
        />
      </div>
    </div>
  );
}
